export const BUSINESS_TYPES = [
  { value: "SOLE_PROPRIETOR", label: "Sole Proprietor" },
  { value: "PARTNERSHIP", label: "Partnership" },
  { value: "LIMITED_LIABILITY_CORPORATION", label: "LLC" },
  { value: "CO_OPERATIVE", label: "Co-operative" },
  { value: "NON_PROFIT_CORPORATION", label: "Non-Profit" },
  { value: "CORPORATION", label: "Corporation" },
];

export const INDUSTRIES = [
  { value: "AUTOMOTIVE", label: "Automotive" },
  { value: "AGRICULTURE", label: "Agriculture" },
  { value: "BANKING", label: "Banking" },
  { value: "CONSTRUCTION", label: "Construction" },
  { value: "CONSUMER", label: "Consumer" },
  { value: "EDUCATION", label: "Education" },
  { value: "ENGINEERING", label: "Engineering" },
  { value: "ENERGY", label: "Energy" },
  { value: "ENTERTAINMENT", label: "Entertainment" },
  { value: "FINANCIAL", label: "Financial" },
  { value: "HEALTHCARE", label: "Healthcare" },
  { value: "HOSPITALITY", label: "Hospitality" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "LEGAL", label: "Legal" },
  { value: "MANUFACTURING", label: "Manufacturing" },
  { value: "MEDIA", label: "Media" },
  { value: "NOT_FOR_PROFIT", label: "Not for Profit" },
  { value: "REAL_ESTATE", label: "Real Estate" },
  { value: "RETAIL", label: "Retail" },
  { value: "TECHNOLOGY", label: "Technology" },
  { value: "TRANSPORTATION", label: "Transportation" },
];

export const JOB_POSITIONS = [
  { value: "DIRECTOR", label: "Director" },
  { value: "GM", label: "General Manager" },
  { value: "VP", label: "Vice President" },
  { value: "CEO", label: "CEO" },
  { value: "CFO", label: "CFO" },
  { value: "GENERAL_COUNSEL", label: "General Counsel" },
  { value: "OTHER", label: "Other" },
];

export const USE_CASES = [
  { value: "MIXED", label: "Mixed" },
  { value: "LOW_VOLUME", label: "Low Volume" },
  { value: "CUSTOMER_CARE", label: "Customer Care" },
  { value: "ACCOUNT_NOTIFICATION", label: "Account Notification" },
  { value: "DELIVERY_NOTIFICATION", label: "Delivery Notification" },
  { value: "MARKETING", label: "Marketing" },
  { value: "HIGHER_EDUCATION", label: "Higher Education" },
  { value: "PUBLIC_SERVICE_ANNOUNCEMENT", label: "Public Service Announcement" },
  { value: "POLLING_AND_VOTING", label: "Polling and Voting" },
  { value: "SECURITY_ALERT", label: "Security Alert" },
  { value: "TWO_FACTOR_AUTHENTICATION", label: "Two-Factor Authentication" },
];
